import { Component, OnInit } from '@angular/core';
import {AngularFirestore} from 'angularfire2/firestore';
@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
